export const APP_NAME = 'changeVehicle';
